import { render, staticRenderFns } from "./Lienholders.vue?vue&type=template&id=5924a948&scoped=true"
import script from "./Lienholders.vue?vue&type=script&lang=js"
export * from "./Lienholders.vue?vue&type=script&lang=js"
import style0 from "./Lienholders.vue?vue&type=style&index=0&id=5924a948&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5924a948",
  null
  
)

export default component.exports